// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .store-item{
    position: relative;
}

.store-item span{
    color: red;
    position: absolute;
    bottom: 15px;
    text-align: center;
    right: 15px;
} */

.bestseller_card .thumble-img{
    height: 264px;
    display: flex;
    background-position: -20px 0px;
    background-size: 122% 122%;
    background-repeat: no-repeat;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/new_stores/newStores.css"],"names":[],"mappings":"AAAA;;;;;;;;;;GAUG;;AAEH;IACI,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;AACf","sourcesContent":["/* .store-item{\n    position: relative;\n}\n\n.store-item span{\n    color: red;\n    position: absolute;\n    bottom: 15px;\n    text-align: center;\n    right: 15px;\n} */\n\n.bestseller_card .thumble-img{\n    height: 264px;\n    display: flex;\n    background-position: -20px 0px;\n    background-size: 122% 122%;\n    background-repeat: no-repeat;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
